import type { ThemeOptions } from "@mui/material";

export const FixAutoThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#033156",
    },
    secondary: {
      main: "#337ab7",
    },
    background: {
      default: "#E6EBF0",
      paper: "#FAFAFA",
    },
  },
};
